import { useDispatch, useSelector } from 'react-redux';
import { useRef, useEffect, useCallback } from 'react';
import {
  reportFilterFranchiseTypeSelector,
  changeReportFilterFranchiseType,
  reportFilterStoresSelector,
  reportFilterCountryCodeSelector,
} from '../../../state';
import FranchiseTypeFilter from '../../filters/FranchiseTypeFilter';
import { FranchiseType } from '../../../types';

const FranchiseTypeFilterRedux = ({ fullWidth }: { fullWidth?: boolean }) => {
  const dispatch = useDispatch();
  const value = useSelector(reportFilterFranchiseTypeSelector) as FranchiseType[];

  const countryCode = useSelector(reportFilterCountryCodeSelector);
  const store = useSelector(reportFilterStoresSelector);
  const disabled = !countryCode || store?.length > 0;

  const handleChange = useCallback(
    (value: FranchiseType[]) => {
      dispatch(changeReportFilterFranchiseType(value));
    },
    [dispatch]
  );

  const initialized = useRef(false);

  useEffect(() => {
    if (!initialized.current && !value?.length && countryCode) {
      dispatch(changeReportFilterFranchiseType([FranchiseType.N, FranchiseType.Y]));
      initialized.current = true;
    }
  }, [value, dispatch, countryCode]);

  return (
    <FranchiseTypeFilter
      fullWidth={fullWidth}
      value={value}
      onChange={handleChange}
      disabled={disabled}
    />
  );
};

export default FranchiseTypeFilterRedux;
